<template>
  <div class="textField" >
    <div class="fieldName">
      {{field}}: &nbsp;
    </div>
    <div>
       <div>
        <input
        v-model="search"
          @input="onChange"
           v-on:keyup.enter="onEnter"
          type="text"
          @click="isOpen=true"
        />
        </div>
        <div>
          
       
      <ul
      v-show="isOpen"
        class="autocomplete-results"
      >
        <li
          v-for="(result, i) in results"
          :key="i"
          @click="setResult(result)"
          class="autocomplete-result"
        >
          {{result}}
          
        </li>
      </ul>
      </div>
    </div>
     <ValidIcon :valid="isValid" :label="error" style="margin-top:10px;font-size:16px;"></ValidIcon>
   
  </div>
</template>

<script>
import ValidIcon from '@/components/ValidIcon.vue';
import Validate from '@/mixins/validate.js'
export default {
  name: 'textInput',
  mixins:[Validate],
  components:{ValidIcon},
  props: {
    items: {
      type: Array,
      required: false,
      default: () => [],
    },
    field: {
      type: String,
      required: false,
      default: () => "",
    },
    showAdd: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    doAdd:{
      type:Function,
      required: false,
       default: () => null,
    },
    validation: {
            type: Array,
            required: false,
            default: () => [],
        },
  },
  data() {
    return {
      search: '',
      results: [],
      isOpen: false,
    };
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
    this.results=this.items
  },
  destroyed() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  methods: {
    onEnter: function() {
       this.isOpen=false
    },
    clearField(){
          this.search=""
        },
    filterResults() {
      this.results = this.items.filter(item => item.toLowerCase().indexOf(this.search.toLowerCase()) > -1);
    },
    setResult(result) {
      this.search = result;
      this.isOpen = false;
    },
    onChange() {
      this.filterResults();
      this.isOpen = true;
       this.updateVal()
    },
    handleClickOutside(event) {
      let self=this
      if (!this.$el.contains(event.target)) {
        self.isOpen = false;
      }
    }
  },
  watch:{
    search(){
        this.updateVal()
    },
    items(val){
      this.results=this.items
        this.filterResults()
     }
  }
  
  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "@/css/colors.scss";
  .textField{
    display:flex;
    margin:10px;
    flex-wrap: wrap;
  }
  input{
    
    font-size: inherit;
  }
  .btn{
    cursor:pointer;
    width:40px;
    border:solid #000 1px;
    border-radius:3px;
    margin:0px 5px;

  }
  
 .autocomplete {
    position: relative;
  }

  .autocomplete-results {
    background-color: #fff;
    padding: 0;
    margin: 0;
    border: 1px solid #eeeeee;
    height: 260px;
    width:320px;
    min-height: 1em;
    max-height: 12em;    
    overflow: auto;
  }

  .autocomplete-result {
    list-style: none;
    text-align: left;
    padding: 4px 2px;
    cursor: pointer;
  }

  .autocomplete-result:hover {
     background-color: $dropdown-selectBG;
    color: $dropdown-select;
  }
</style>
